import { motion } from "framer-motion";
import PageHeader from "@/components/PageHeader";

const IMAGES = [
    "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=1600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=1600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=1600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1493809842364-78817add7ffb?q=80&w=1600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1487958449943-2429e8be8625?q=80&w=1600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1493397212122-2b85dda8106b?q=80&w=1600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?q=80&w=1600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?q=80&w=1600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=1600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1497366754035-f200968a6e72?q=80&w=1600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1449844908441-8829872d2607?q=80&w=1600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1600566752355-35792bedcfea?q=80&w=1600&auto=format&fit=crop",
];

// Bento pattern classes for a "tetris" gallery
const SPANS = [
    "md:col-span-8 aspect-[16/9]",
    "md:col-span-4 aspect-[4/5]",
    "md:col-span-4 aspect-[4/5]",
    "md:col-span-4 aspect-[4/5]",
    "md:col-span-4 aspect-[4/5]",
    "md:col-span-8 aspect-[16/9]",
    "md:col-span-6 aspect-[4/3]",
    "md:col-span-6 aspect-[4/3]",
    "md:col-span-12 aspect-[16/7]",
    "md:col-span-4 aspect-[4/5]",
    "md:col-span-4 aspect-[4/5]",
    "md:col-span-4 aspect-[4/5]",
];

const EASE = [0.22, 1, 0.36, 1];

export default function Gallery() {
    return (
        <div data-testid="page-gallery">
            <PageHeader
                eyebrow="Gallery — a walk through the archive"
                title={<>Twelve fragments, <em className="italic text-lime">unarranged.</em></>}
                lead="Concrete, stone, light, water. Details from active sites and delivered residences — photographed slowly, on film where possible."
            />
            <section className="relative bg-forest-950 py-16 md:py-24">
                <div className="mx-auto max-w-[1440px] px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
                    {IMAGES.map((src, i) => (
                        <motion.div
                            key={i}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-8% 0px" }}
                            transition={{ duration: 0.95, ease: EASE, delay: (i % 4) * 0.05 }}
                            data-testid={`gallery-tile-${i}`}
                            className={`relative overflow-hidden bg-forest-800 group ${SPANS[i % SPANS.length]}`}
                        >
                            <img
                                src={src}
                                alt="Gallery"
                                loading="lazy"
                                className="h-full w-full object-cover transition-transform duration-[1.5s] group-hover:scale-105"
                            />
                            <div className="absolute bottom-4 left-4 font-mono-mini text-[10px] tracking-[0.32em] uppercase text-ivory/90 opacity-0 group-hover:opacity-100 transition-opacity">
                                Frame · {String(i + 1).padStart(2, "0")}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </section>
        </div>
    );
}
